import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { IoMdAddCircle } from "react-icons/io";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { addProductCategory, updateProductCategory } from "../../../redux/reducers/productSlice";
import { FaRegEdit } from "react-icons/fa";
import Spinner from "../../../components/Spinner";

export default function AddProductCategory({ type, data }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { loading } = useSelector((state) => state.product);
  const businessId = localStorage.getItem("activeBusinessId");

  //formik initial values
  const initialValues = {
    name: type === "update" ? data?.name : "",
    description: type === "update" ? data?.description : "",
    id: type === "update" && data?._id,
    businessId: type === "update" ? data?.business : businessId,
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
  });

  const dispatch = useDispatch();
  const onSubmit = (values, { setFieldError }) => {
    if (type === "add") {
      dispatch(addProductCategory(values)).then((res) => {
        if (res.payload?.status !== "error") {
          handleClose();
        }
      });
    } else {
      dispatch(updateProductCategory(values)).then((res) => {
        if (res.payload?.status !== "error") {
          handleClose();
        }
      })
    }
  };
  return (
    <div>
      {/* <div onClick={handleShow} style={{ cursor: 'pointer' }}>
        {type === "add" ? (
          <IoMdAddCircle />
        ) : (
          <FaRegEdit className="mx-2" size={15} />
        )}
      </div> */}
      <div onClick={handleShow} style={{ cursor: 'pointer' }}>
        {type === "add" ? (
          <button className="btn btn-primary d-flex align-items-center gap-2">
            <IoMdAddCircle size={20} /> New Category
          </button>
        ) : (
          <div className="action-icon-edit text-primary p-2 rounded-circle bg-light d-flex align-items-center justify-content-center" title="Edit Category">
            <FaRegEdit size={16} />
          </div>
        )}
      </div>
      <Modal
        show={show}
        onHide={() => !loading && handleClose()}
        size="md"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton={!loading}>
          <Modal.Title>
            {type === "add" ? "Add Category" : "Update Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Spinner active={loading}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {(formik) => {
                return (
                  <Form>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-xxl-12 col-lg-12 col-md-12 col-12 mb-3">
                          <label className="form-label fw-bold small">
                            Category Name <span className="text-danger">*</span>
                          </label>
                          <Field
                            type="text"
                            name="name"
                            className="gbl-input"
                            placeholder="Enter Category Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="formik_red_txt small mt-1"
                          />
                        </div>
                        <div className="col-xxl-12 col-lg-12 col-md-12 col-12 mb-3">
                          <label className="form-label fw-bold small">Description <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="description"
                            className="gbl-input"
                            placeholder="Enter Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="formik_red_txt small mt-1"
                          />
                        </div>
                      </div>
                      <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button
                          variant="light"
                          onClick={handleClose}
                          disabled={loading}
                          className="rounded-pill px-4 fw-bold"
                        >
                          Cancel
                        </Button>
                        <button
                          className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm"
                          type="submit"
                          disabled={loading}
                        >
                          {type === "add" ? `Create Category` : `Save Changes`}
                        </button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Spinner>
        </Modal.Body>
      </Modal>
    </div>
  );
}
